import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CurrentPlanCard = ({ plan, subscription, onUpgrade, onCancel }) => {
  const formatDate = (dateStr) => {
    if (!dateStr) return 'N/A';
    return new Date(dateStr)?.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  const formatPrice = (amount) => {
    if (amount === null || amount === undefined || amount === 0) return 'Free';
    // If amount > 1000, it's stored in cents — convert to dollars
    const dollars = amount > 1000 ? Math.round(amount / 100) : Number(amount);
    return `$${dollars}/mo`;
  };

  // Support both plan.price and plan.amount fields
  const priceValue = plan?.price !== undefined ? plan?.price : plan?.amount;

  const getPlanBadgeColor = (planName) => {
    const colors = {
      Free: 'bg-green-100 text-green-800',
      Basic: 'bg-blue-100 text-blue-800',
      Professional: 'bg-purple-100 text-purple-800',
      Premium: 'bg-pink-100 text-pink-800',
      Enterprise: 'bg-gray-100 text-gray-800',
    };
    return colors?.[planName] || 'bg-blue-100 text-blue-800';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
      <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
        <div className="flex items-center space-x-4">
          <div className="p-3 bg-primary/10 rounded-lg">
            <Icon name="CreditCard" size={24} className="text-primary" />
          </div>
          <div>
            <div className="flex items-center space-x-2">
              <h2 className="text-xl font-bold text-foreground">{plan?.name || 'Free'} Plan</h2>
              <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${getPlanBadgeColor(plan?.name)}`}>
                {plan?.name || 'Free'}
              </span>
            </div>
            <p className="text-muted-foreground font-medium">{formatPrice(priceValue)}</p>
            {plan?.description && (
              <p className="text-sm text-muted-foreground mt-0.5">{plan?.description}</p>
            )}
          </div>
        </div>
        <div className="flex items-center space-x-3">
          <span className={`px-3 py-1 rounded-full text-sm font-medium ${
            plan?.status === 'active' ? 'bg-success/10 text-success' : 'bg-muted text-muted-foreground'
          }`}>
            {plan?.status === 'active' ? '● Active' : plan?.status || 'Inactive'}
          </span>
          {plan?.name !== 'Enterprise' && (
            <Button variant="default" size="sm" onClick={onUpgrade} iconName="ArrowUp" iconPosition="left">Upgrade</Button>
          )}
          {subscription?.id && plan?.name !== 'Free' && (
            <Button variant="outline" size="sm" onClick={onCancel}>Cancel</Button>
          )}
        </div>
      </div>

      {subscription && (
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4 pt-4 border-t border-border">
          <div>
            <p className="text-xs text-muted-foreground">Billing Cycle</p>
            <p className="text-sm font-medium text-foreground capitalize">{plan?.billingCycle || subscription?.billing_interval || 'Monthly'}</p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground">Next Billing Date</p>
            <p className="text-sm font-medium text-foreground">{formatDate(plan?.nextBilling || subscription?.current_period_end)}</p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground">Member Since</p>
            <p className="text-sm font-medium text-foreground">{formatDate(subscription?.created_at)}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CurrentPlanCard;